/* eslint-disable no-restricted-imports */
import { DpContainer } from '@/components/blocks/DpContainer';
import { useIsOpen } from '@/utils/useIsOpen';
import { Box, SxProps } from '@mui/material';
import React, { useEffect } from 'react';

declare function setupIframePlayerWithLatestLive(id: string): Promise<void> | void;

interface FiraLiveProps {
	withoutmargin?: boolean;
	framesx?: SxProps;
	sx?: SxProps;
}

const scriptId = 'fira-live-widget';
const containerId = 'dp-fira-live';
const FIRA_SCRIPT_URL = 'https://firalivepro.blob.core.windows.net/fira-live-widget/index.min.js';
const FIRA_KEY = '66820e425c559f1c0c7611ab';

const ensureSingleChild = (container: HTMLElement | null) => {
	if (container) {
		const childrenArray = Array.from(container.children);
		childrenArray.slice(1).forEach((child) => container.removeChild(child));
	}
};

export const DpFiraLive: React.FC<FiraLiveProps> = ({ withoutmargin = true, framesx, sx }) => {
	const flagFiraScript = useIsOpen();

	useEffect(() => {
		if (flagFiraScript.open) {
			return;
		}

		const script = document.createElement('script');
		script.src = FIRA_SCRIPT_URL;
		script.id = scriptId;
		script.setAttribute('fira-key', FIRA_KEY);
		script.onload = flagFiraScript.on;

		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, [flagFiraScript]);

	useEffect(() => {
		if (!flagFiraScript.open) {
			return;
		}

		(async () => {
			const container = document.getElementById(containerId);

			if (container && container.children.length === 0) {
				if (typeof setupIframePlayerWithLatestLive === 'function') {
					await setupIframePlayerWithLatestLive(containerId);
				}
			}

			ensureSingleChild(container);
		})();

		return () => {
			const container = document.getElementById(containerId);
			if (container) {
				container.innerHTML = '';
			}
		};
	}, [flagFiraScript.open]);

	return (
		<DpContainer withoutmargin={withoutmargin} framesx={framesx} sx={sx}>
			<Box component="div" id="dp-fira-live" />
		</DpContainer>
	);
};
